import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { useLocation, useParams } from 'react-router-dom';
import qs from 'query-string';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const useB2cStudent = () => {
  /* ======================================================
   * state
   * ====================================================== */
  const [lectureInfo, setLectureInfo] = useState<LectureInfoDto>({
    id: 0,
    lecture_title: '',
    start_date: '',
    end_date: '',
    lecture_place: '',
    lecture_price: 0,
    max_price: 0,
    memo: '',
    close_yn: '',
    lecture_sale_yn: '',
    lecture_cha: 1,
    lecture_gid: 0,
    student_max: 0,
  });
  const [studentList, setStudentList] = useState<StudentListDto[]>([]);
  const [delList, setDelList] = useState<StudentListDto[]>([]);

  const {id} = useParams();    
  /* ======================================================
   * hooks
   * ====================================================== */
  const location = useLocation();

  const searchParams = qs.parse(location.search);
  const { refetch } = useQuery(
    [endpoints.b2c.student.list, id],
    () =>
      fetcher.b2c.postStudentList({
        id: Number(id),        
      }),
    {
      onSuccess: (res: StudentInfoResDto) => {
        switch (res.code) {
          case 200:
            if (res.result) {
              setLectureInfo(res.result.info);
              setStudentList(res.result.list);
              setDelList(res.result.dellist);
            } else {
              setLectureInfo({
                id: 0,
                lecture_title: '',
                start_date: '',
                end_date: '',
                lecture_place: '',
                lecture_price: 0,
                max_price: 0,
                memo: '',
                close_yn: '',
                lecture_sale_yn: '',
                lecture_cha: 1,
                lecture_gid: 0,
                student_max: 0,
              });
              setStudentList([]); 
              setDelList([]);
            }
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: memoUpdate, isSuccess: updateSuccess } = useMutation(
    [endpoints.b2c.update_memo],
    fetcher.b2c.postProjectMemoUpdate,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            refetch();
            message.info(MSG.SUCCESS_SAVE, 1);
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  return { lectureInfo, studentList, delList, refetch, memoUpdate, updateSuccess };
};

export default useB2cStudent;
